import { Helpers } from '../../helpers';
import { IProjectEstimateStatus } from '../../interfaces/iproject-estimate-status';
import { ProjectEstimate } from '../project-estimate';
import { ProjectResourceItem } from '../project-resource-item';

export class ProjectEstimateStatusBase {
  ProjectEstimateStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectEstimates_ProjectEstimateStatus?: Array<ProjectEstimate> | null;
  ProjectResourceItems_ProjectEstimateStatus?: Array<ProjectResourceItem> | null;

  constructor(item?: IProjectEstimateStatus) {
    if (item) {

      this.ProjectEstimateStatusId = item.ProjectEstimateStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectEstimates_ProjectEstimateStatus = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_ProjectEstimateStatus);
      this.ProjectResourceItems_ProjectEstimateStatus = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_ProjectEstimateStatus);
    }
  }
}